<script setup>
import { watch, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useTipStore } from "@/store/tip-store";

const route = useRoute();
const hideHeaderFooter = ref(false);
const tipStore = useTipStore();

watch(route, (to) => {
  if (to.meta.hideHeaderFooter) {
    hideHeaderFooter.value = to.meta.hideHeaderFooter;
  }
});

const tipSet = computed(() => {
  return tipStore.state.tipSet;
});

const mainClass = computed(() => {
  let defaultClass = "bg-dark text-white";
  if (hideHeaderFooter.value) {
    defaultClass = "container-fluid py-0 my-0 mx-0 px-0";
  }
  return defaultClass;
});
</script>
<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-dark"
    v-if="!hideHeaderFooter"
  >
    <div class="container">
      <routerLink class="navbar-brand" to="/">
        <img
          class="navbar-brand-logo"
          src="/assets/images/djsaturn-logo.svg"
          alt="DJ Saturn"
        />
      </routerLink>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <routerLink
              class="nav-link"
              :class="routeName == 'tip' ? 'active' : ''"
              :to="{ name: 'tip' }"
            >
              Tip <span class="badge text-bg-success" v-if="tipSet">1</span>
            </routerLink>
          </li>
          <li class="nav-item">
            <routerLink
              class="nav-link"
              :to="{ name: 'home', hash: '#videoMixes' }"
              >Mixes</routerLink
            >
          </li>
          <li class="nav-item">
            <routerLink
              class="nav-link"
              :to="{ name: 'home', hash: '#contact' }"
              >Contact</routerLink
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <main :class="mainClass">
    <router-view />
  </main>
  <footer class="mt-auto" v-if="!hideHeaderFooter">
    <div class="container pb-3">
      <hr />
      <div
        class="row align-items-center justify-content-between flex-column flex-sm-row"
      >
        <div class="col-auto">
          <div class="small m-0 text-white">
            Copyright © djsaturn.com {{ new Date().getFullYear() }}
          </div>
        </div>
        <div class="col-auto">
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <a
                class="btn btn-xs btn-light"
                href="https://www.instagram.com/djs4turn"
                target="_blank"
              >
                <i class="bi bi-instagram"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a
                class="btn btn-xs btn-light"
                href="https://twitter.com/djsaturn"
                target="_blank"
              >
                <i class="bi bi-twitter"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a
                class="btn btn-xs btn-light"
                href="https://www.youtube.com/djs4turn"
                target="_blank"
              >
                <i class="bi bi-youtube"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a
                class="btn btn-xs btn-light"
                href="https://www.twitch.tv/djsaturn_"
                target="_blank"
              >
                <i class="bi bi-twitch"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<style scoped>
.navbar-brand-logo {
  width: 100%;
  min-width: 10rem;
  max-width: 10rem;
}
</style>
